import { Briefcase, Search, Sprout, ArrowRight, MessageCircle, Compass } from "lucide-react";

const ask = (message) => window.dispatchEvent(new CustomEvent("kesh-ask", { detail: { message } }));
const focusField = (id) => { const el = document.getElementById(id); el?.scrollIntoView({ behavior: "smooth", block: "center" }); el?.focus({ preventScroll: true }); };

const TIPS = {
  employed: {
    icon: Briefcase, title: "Looking while you're still in a job",
    points: ["Keep it quiet: apply from your personal email and phone, and use your own device and time.",
      "Send fewer, better applications. A CV tailored to each job beats a general one.",
      "Get interview times that suit your work hours, like early morning, lunch or video calls."],
    actions: [["Tailor a CV to a job", (go) => go("studio")], ["Ask Kesh", () => ask("How do I job hunt without my employer finding out?"), true]],
  },
  looking: {
    icon: Search, title: "Make every application count",
    points: ["Aim for a few well-matched jobs each week rather than dozens of quick ones.",
      "Tailor your CV to each job ad. Matching their wording helps you get past the screening software.",
      "Track every application and follow up politely about a week after applying."],
    actions: [["Start a tailored application", (go) => go("studio")], ["Track my applications", (go) => go("tracker"), true]],
  },
  unemployed: {
    icon: Sprout, title: "Make a career gap work for you",
    points: ["You don't need to hide a gap. One honest line is enough, like \"Career break: caring for family\" or \"Upskilling in data analytics\".",
      "Add any courses, volunteering or freelance work from that time, so your CV shows you kept growing. SkillsFuture courses count too.",
      "Lead with your skills and results, so a recruiter sees what you can do before they look at dates."],
    actions: [["Add courses to my profile", () => focusField("profile-certifications")], ["Ask Kesh how to explain my gap", () => ask("How should I explain a career gap on my CV and in interviews?"), true]],
  },
};

export default function StatusTips({ status, onGo }) {
  const t = TIPS[status];
  if (!t) return (
    <div className="gi-card p-5 flex items-start gap-3" data-testid="status-tips-empty">
      <Compass className="w-5 h-5 text-brand mt-0.5 shrink-0" aria-hidden="true" />
      <p className="text-sm text-body">Choose your work status at the top to get next steps for your situation.</p>
    </div>
  );
  const Icon = t.icon;
  return (
    <section className="gi-card p-5 sm:p-6 border-brand/20" data-testid={`status-tips-${status}`}>
      <div className="flex items-center gap-2.5">
        <span className="w-9 h-9 rounded-xl bg-brand-soft text-brand flex items-center justify-center shrink-0"><Icon className="w-5 h-5" aria-hidden="true" /></span>
        <div>
          <div className="text-xs font-semibold uppercase tracking-wider text-brand-text">Your next step</div>
          <h2 className="font-display text-lg font-bold text-ink" data-testid="status-tips-title">{t.title}</h2>
        </div>
      </div>
      <ul className="mt-4 space-y-2.5">
        {t.points.map((x) => (
          <li key={x} className="flex gap-2.5 text-[15px] text-body leading-relaxed"><span className="w-1.5 h-1.5 rounded-full bg-brand mt-2.5 shrink-0" aria-hidden="true" />{x}</li>
        ))}
      </ul>
      <div className="mt-5 flex flex-wrap gap-2.5">
        {t.actions.map(([label, run, secondary], i) => (
          <button key={label} data-testid={`status-tips-action-${i}`} onClick={() => run(onGo)} className={`gi-btn gi-btn-sm ${secondary ? "gi-btn-secondary" : "gi-btn-primary"}`}>
            {label.startsWith("Ask Kesh") ? <MessageCircle className="w-4 h-4" aria-hidden="true" /> : null} {label} {!secondary && <ArrowRight className="w-4 h-4" aria-hidden="true" />}
          </button>
        ))}
      </div>
    </section>
  );
}
